import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalChangePassword from "root/Modals/ChangePassword/ModalChangePassword";

const useModalChangePassword = (user_id, onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, user_id: null })  ;

    const onClickActivate = ( user_id ) =>
    {
        setDialog ({ openState: true, user_id: user_id});
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, user_id: null, key: null});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, user_id: null});

        // Tell the parent we're done
        onSaveCompleted() ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                < ModalChangePassword user_id={dialog.user_id} onSaveCompleted={onSaveComplete} onClose={onCloseModal} title="Change Password" />
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalChangePassword ;
